import { render, staticRenderFns } from "./projectorbit.vue?vue&type=template&id=3845cbaa&scoped=true"
import script from "./projectorbit.vue?vue&type=script&lang=js"
export * from "./projectorbit.vue?vue&type=script&lang=js"
import style0 from "./projectorbit.vue?vue&type=style&index=0&id=3845cbaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845cbaa",
  null
  
)

export default component.exports